import { render } from "./IconDropdownButton.vue?vue&type=template&id=223220d1&scoped=true"
import script from "./IconDropdownButton.vue?vue&type=script&lang=js"
export * from "./IconDropdownButton.vue?vue&type=script&lang=js"

import "./IconDropdownButton.vue?vue&type=style&index=0&id=223220d1&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223220d1"]])

export default __exports__